export const convertToCommaSeparatedValue = (array: any[]) => {
    if (array.length === 0) return '';
    if (array.length === 1) return array[0].name;

    const names = array.map(item => item.name);
    const lastName = names.pop();
    return `${names.join(", ")} & ${lastName}`;
};